import { render, staticRenderFns } from "./view-periods.vue?vue&type=template&id=dc041bd8"
import script from "./view-periods.ts?vue&type=script&lang=ts&external"
export * from "./view-periods.ts?vue&type=script&lang=ts&external"
import style0 from "./view-periods.scss?vue&type=style&index=0&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('dc041bd8')) {
      api.createRecord('dc041bd8', component.options)
    } else {
      api.reload('dc041bd8', component.options)
    }
    module.hot.accept("./view-periods.vue?vue&type=template&id=dc041bd8", function () {
      api.rerender('dc041bd8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/admin-periods/view-periods/view-periods.vue"
export default component.exports